/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-04-01 16:27:02
 * @LastEditors: Mayer
 * @LastEditTime: 2024-10-08 16:41:04
 */
export default {
  lang: "英语",
  landing: {
    name1: "Open Carlcare",
    name2: "Reservation now",
    name3: "With Carlcare, you can check your order at any time.",
    name4: "Verification code",
    name5: "Slide to the right",
    name6: "Verification complete",
    name8: "Replace with Original & Guaranteed Battery", // 活动标题 副标题
    name9: "Enjoy Carlcare Battery Replacement Service !", // 标题
    name10: "Enjoy an original battery replacement service for designated Infinix/Tecno/itel models, now available at Up to 50% off!",
    name11: "- Battery prices vary by model. Please check the updated price list below for more details.",
    name12: 'The battery price may vary depending on the model. Please refer to the price list below for details.', // 小字标注
    name13: "Why Choose Carlcare Battery Replacement ?",
    name14: "Original and Reliable",
    name15: "100% official spare parts perfectly fit your device.",
    name18: "3-Month Warranty",
    name19: "Get a 3-month official warranty for your new battery.",
    name20: "Lower and Affordable Price",
    name21: "Get a great discount on battery prices.",
    name22: "Worry-Free Repairs",
    name23: "Professional repairs with guaranteed long-lasting quality.",
    name25: "1. The replaced battery under this promotion comes with a 3-month official warranty.",
    name26: "2. This promotion is applicable for battery replacements only and is limited to specific models.",
    name27: "3. This promotion cannot be combined with other offers. Limited stock, while supplies last.",
    name28: "4. Carlcare reserves the final right to interpret this promotion.For inquiries or assistance, please call Carlcare Hotline at: 07080632363.",
    name29: "5. The promotion is currently available at selected stores only. For more details, please refer to the specific service locations.",
    name30: "6. Carlcare reserves the final right to interpret this promotion.For inquiries or assistance, please call Carlcare hotline at 02-8705-4200.",
    name31: "Carlcare Service Statements:",
    name32: "Flat Price Battery",
    name33: "Replacement",
    name34: "Starting from ₱500",
    name35: "Battery Price List",
    name36: "Brand",
    name37: "Series",
    name38: "Model",
    name39: "Price",
    name40: "Original Battery",
    name41: "Affordable Price",
    name42: "Free Labor Fee",
  },
  order: {
    name1: "Xullo nooca aaladda",
    name2: "Khalad Sharaxaad:",
    name3: "Taabo sida dooro adeegga kaydinta",
    name4: "Kaydhinta Adeegga:",
    name5: "Waqtiga Boos celis:",
    name6: "Fadlan si faahfaahsan u sharax dhibaatada aaladdaada!",
    name7: "Taabo sida dooro waqtiga imaanshaha",
    name8: "Fadlan gali faahfaahinta xiriirkaaga si aan kuu helno",
    name9: "Waqtiga boos celinta ee la heli karo waa sida soo socota",
    name10: "Fadlan gali lambarka telefoonkaaga",
    name11: "Qiimo",
    name12: "Maclumadka shaqsiyeed:",
    name13: "Fadlan gali magacaaga",
    name14: "Soo dir",
    name15: "Jooji",
    name16: "Haye",
  },
  shops: {
    name1: "Kusaleysan summada adiga xullo ,Kaydinta soo socdaa way kuu adeegsan karaan!",
    name2: "Imaatinka ugu dhakhsaha badan dukaamada tafaariiqda! Nala joog!",
  },
  price: {
    name1: "Summad",
    name2: "Tusaale",
    name3: "SHAYADA",
    name4: "Qiimo",
    name5: "Xusuusin Saaxiibtinimo:",
    name6: "Qiimahani waa tixraac kaliya,iyo qiimaha dhabta ah wuxuu ku xiran yahay xaaladda aaladdaada.",
    name7: "Haddii aysan jirin astaan gaar ah, qaybta qiimaha waa unugga lacagta maxalliga ah.",
    name8: "Waan ka xumahay! Faahfaahin qiimo lagama heli karo gobolka hadda jira.",
    name11:"Qiimaha Shaqada",
    name12:"Wadarta Qiimaha",
    name13: "5. Haddii qiimaha shaqadu yahay \"/\", waxay la macno tahay in kharashka shaqadu uu u baahan yahay in lagala tashado dukaanka.",
    item_main_board: "Boodhka weyn",
    item_screen_frame: "Shaashada (Qaabka)",
    item_screen_screen_frame: "Shaashada Labaad (Qaabka)",
    item_touch_screen: "Shaashada Taabo",
    item_camera: "Kamarada",
    item_fixed_focus_camera: "Kamera Diirada Saaran",
    item_auto_focus_camera: "Kamera Diirada-saarista",
    item_screen: "Shaashada",
    item_secondary_screen: "Shaashada Labaad",
    item_fingerprint_module: "Cutubka Farsaarka",
    item_speaker: "Makarafon",
    item_receiver: "Helaha",
    item_small_board: "Guddi yar",
    item_battery_cover: "Daboolka batariga",
    item_battery: "Battariga",
    item_charger: "Bixiyaha",
    item_usb_cable: "Xariga USB",
    item_lcd: "LCD",
  },
  shopDetails: {
    name1: "Malahan xog",
    name2: "Adeeg bixiye:",
    name3: "Summada Adeegga",
    name4: "Telefon :",
    name5: "Tirada ee Dalabka:",
    name6: "Qiimeynta Adeegga",
    name7: "Deegaanka Adeegga:",
    name8: "Dabeecada Adeegga:",
    name9: "Hufnaanta Adeegga",
    name10: "Tayada adeegga:",
    name11: "Qiimeynta Macaamiisha",
    name12:"ilaa",
    name13:"Xiran",
    name14:"Address:"
  },
  reserSuccess: {
    // name1:
    //   "Fur Carlcare",
    name1: "Fadlan shaashaddatoogashada macluumaadka boos celinta iyo badaadinta sida rasiid si loo helo adeegga mudnaanta leh.",
    name2: "Si guul leh loo gudbiyay",
    name3: "1. Nadiifi xogta",
    name4: "Fadlan horay ugu sii kaydso xogta muhiim ah oo gaar ah teleefonkaaga",
    name5: "2. Hawlgab ah awoodda-shid eraygasirta ah",
    name6: "Kahor intaadan aadin dukaanka adeegga, fadlan",
    name7: "Kaydhinta Adeegga",
    name8: "Waqtiga Boos celis",
    name9: "Khalad Sharaxaad",
    name10: "Nooca Aaladda",
    name11: "Lambarka dalbashada",
    name12: "Macluumaadka Amarka",
  },
  title: {
    
    name1: "Waxay taageertaa wadamada soo socda:",
    name2: "Xulo Nooca",
    name3: "Boos celinta",
    name4: "Faahfaahinta Kaydinta Adeegga",
    name5: "Dooro Adeegga Kaydinta",
  },
  error: {
    
    name1: "Xogta lama hayo. Fadlan hubi macluumaadkaaga dayactirka",
    name2: "Ma u baahan tahay caawimaad dheeraad ah? Fadlan nala soo xiriir.",
    name3: "Waan ka xumahay, malaha xarun Carlcare gobolka hadda jira.",
    name4: "Fadlan marka hore dooro xarun adeegga",
    name5: "Ku guuldaraystay",
    name6: "Fadlan marka hore xulo nooca aaladda",
    name7: "Faahfaahin",
    name8: "Fadlan sharax baahiyahaaga oo faahfaahsan",
    name9: "",
  },
  add1:{
    "name0": "so",
    "name1": "Dalabkaaga waa la xaqiijiyay. Imaatinkaaga ayaan rajaynaynaa.",
    "name2": "Dooro magaalada",
    "name3": "Fadlan gali lambar teleefon oo %1$s ah",
    "name4": "Saacadaha shaqada",
    "name5": "Isniin",
    "name6": "Talaado",
    "name7": "Arbaco",
    "name8": "Khamiis",
    "name9": "Jimco",
    "name10": "Sabti",
    "name11": "Axad",
    "name12": "Dalka gal iyo raadi"
  },
  add2:{
    "name0": "English",
    "name1": "Repair Method：",
    "name2": "In-store Repairs",
    "name3": "Delivery service",
    "name4": "Fault Type",
    "name5": "Tap to select fault type",
    "name6": "pick-up time",
    "name7": "tap to select pick-up time",
    "name8": "pick-up address",
    "name9": "Pleasee input your house number/street/district/province",
    "name10": "Pleasee input postal code",
    "name11": "Add returning address",
    "name12": "returning address",
    "name13": "Kuwo kale",
    "name14": "Please describle your dexice problem in detail!",
    "name15": "Sending Post Code",
    "name16": "Please input your returning number/street/district/province",
    "name17": "Please input your returning code",
    "name18": "Returning Post Code",
    "name19": "Sending Address",
    "name20": "Choose your province",
  },
  coupons: {
    name1:"Coupons",
    name2:"Taabo si aad dib ugu jihayso",
    name3:"Fur abka Carlcare si aad u qiimeyso dalabka",
    name4:"Navigate by Google Maps",
    name5:"Navigate by Yandex Maps",
    name6:"Dooro Adeeg",
    name7:"Nadiifinta bilaashka ah",
    name8:"Cusbooneysiinta Softiweerka",
  },
  cancelorder:{
    "cancelReason0": "Macluumaad khaldan",
    "cancelReason1": "Kuma iman karo waqtigii loogu talagalay",
    "cancelReason2": "Dalabka nuqul ka samaysan/ma aha dalabkayga",
    "cancelReason3": "Guuldaradu ma soo noqoto",
    "cancelReason4": "Kaliya tijaabada / waydiin / dhacdo /…",
    "cancelReason5": "Qiimaha sare",
    "cancelReason6": "Qalabka yaraanta",
    "cancelReason7": "Malaha adeegyo kala duwan",
    "cancelReason8": "Kaydinta aad buu u fog yahay",
    "cancelReason9": "Kaydinta wuu xiran yahay",
    "cancelReason10": "Dabeecad adeega xumo",
    "cancelReason11": "Beddelka/dayactirka noocyada kale",
    "cancelReason12": "Ma heli karo kaydinta",
    "cancelReason13": "Kale",
    "cancelOrder": "Jooji Dalabka",
    "reason_dialog_title": "Fadlan noo sheeg sababta joojinta",
    "Cancel": "Jooji",
    "OK": "Haye",
    "name1": "Gali xaqiijinta baaqsirta",
    "name2": "Baaqsirta xaqiijin oo aan ansax ahayn",
    "repair_reservation_detail_canceled": "Dalabkani waa lajoojiyay!",
    "purchase_cancel_dialog_content": "Ma xaqiijisaa inaad joojisay dalabka?",
    "yes": "Haa",
    "no": "Maya"
}
};
